import { combineReducers } from "redux";

import Settings from "./Settings";
import Auth from "./Auth";
import Common from "./Common";

// Common
import modalityReducer from "./common/modality-reducer";
import rolesReducer from "./common/roles-reducer";
import skillsReducer from "./common/skills-reducer";
import scanTypesReducer from "./common/scan-types-reducer";
import bodyPartsReducer from "./common/bodyPartsReducer";
import { configurationReducer } from "./common/configurationReducer";

import adminReducer from "./admin";
import rosterReducer from "./rosterReducer";
import reserveReducer from "./reserveReducer";
import addrressReducer from "./common/addressReducer";
import quickCodesReducer from "./receptionist/quickCodesReducer";
import userModalReducer  from "./userModalReducer";

/**
 * Base reducers that are always present
 */
export const staticReducers = {
  settings: Settings,
  auth: Auth,
  commonData: Common,
  modalityTypes: modalityReducer,
  roles: rolesReducer,
  skills: skillsReducer,
  scanTypes: scanTypesReducer,
  bodyParts: bodyPartsReducer,
  admin: adminReducer,
  roster: rosterReducer,
  reserve: reserveReducer,
  address: addrressReducer,
  quickCodes: quickCodesReducer,
  config: configurationReducer,
  userModal: userModalReducer,
};

/**
 * Combines static and async reducers
 */
const createRootReducer = (asyncReducers = {}) =>
  combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });

export default createRootReducer;